export const SITE_NAME = "NetLand Shop";
export const SITE_URL = "https://loja.netland.com.br";
export const SITE_DESCRIPTION =
  "Achadinhos, produtos baratos e ofertas selecionadas para comprar melhor todos os dias.";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/favicon.ico`;

export function absoluteUrl(path = "/") {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_URL}${normalizedPath}`;
}

export function formatCurrencyLabel(price: string) {
  return price.includes("R$") ? price : `R$ ${price}`;
}

export function sanitizeText(value?: string | null) {
  return value?.replace(/\s+/g, " ").trim() || "";
}

export function truncateText(value: string, maxLength: number) {
  if (value.length <= maxLength) {
    return value;
  }

  return `${value.slice(0, Math.max(0, maxLength - 1)).trim()}...`;
}

export function buildCategoryUrl(category?: string | null, subcategory?: string | null) {
  const params = new URLSearchParams();

  if (category) {
    params.set("category", category);
  }

  if (subcategory) {
    params.set("subcategory", subcategory);
  }

  const query = params.toString();
  return query ? `/?${query}` : "/";
}

export function slugify(value?: string | null) {
  const normalized = (value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/-{2,}/g, "-");

  return normalized || "produto";
}

export function buildProductUrl(productId: string, productName?: string | null) {
  return `/product/${productId}/${slugify(productName)}`;
}
